import { isHomeViewOrganization } from '@upright/common/iam/organizations/home-view-organization-types';
import { OrganizationType } from '@upright/common/iam/organizations/organization-types';

/** A company shell must select its own organisations, not the investor-only list. */
export function selectableHomeOrganizations<T extends { type: OrganizationType }>(
  organizations: T[] | undefined,
  companyShell: boolean,
): T[] | undefined {
  return organizations?.filter(org =>
    companyShell ? org.type === OrganizationType.COMPANY : isHomeViewOrganization(org),
  );
}
